export default "__VITE_ASSET__Dze1QLXR__"